// store/userSlice.js
import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
  name: "user",
  initialState: {
    username: localStorage.getItem("username") || "",
    userId: localStorage.getItem("userid") || "",
    roleName: localStorage.getItem("roleName") || "super_admin",
    userProfilePic: localStorage.getItem("userProfilePic") || "/avatar.svg",
    userProfilePicDownloadUrl:
      localStorage.getItem("userProfilePicDownloadUrl") || "/avatar.svg",
    advisorName: localStorage.getItem("advisorName") || "",
    customerName: localStorage.getItem("customerName") || "",
    subAdvisorName: localStorage.getItem("subAdvisorName") || "",
    fileIdsRedux: [],
    cardCurrencyName: JSON.parse(localStorage.getItem("cardCurrencyName")) || {
      value: 2,
      label: "AUD",
      symbol: "$",
    },
    updateFieldStatus: false,
  },
  reducers: {
    setUsername: (state, action) => {
      localStorage.setItem("username", action.payload);
      state.username = action.payload;
    },
    setUserIdStore: (state, action) => {
      localStorage.setItem("userid", action.payload);
      state.userId = action.payload;
    },
    setUserProfilePicDownloadUrl: (state, action) => {
      localStorage.setItem("userProfilePicDownloadUrl", action.payload);
      state.userProfilePicDownloadUrl = action.payload;
    },
    setUserProfilePic: (state, action) => {
      localStorage.setItem("userProfilePic", action.payload);
      state.userProfilePic = action.payload;
    },
    setRoleName: (state, action) => {
      localStorage.setItem("roleName", action.payload);
      state.roleName = action.payload;
    },
    setAdvisorNameRedux: (state, action) => {
      localStorage.setItem("advisorName", action.payload);
      state.advisorName = action.payload;
    },
    setCustomerNameRedux: (state, action) => {
      localStorage.setItem("customerName", action.payload);
      state.customerName = action.payload;
    },
    setSubAdvisorNameRedux: (state, action) => {
      localStorage.setItem("subAdvisorName", action.payload);
      state.subAdvisorName = action.payload;
    },
    setCardCurrencyName: (state, action) => {
      localStorage.setItem("cardCurrencyName", JSON.stringify(action.payload)); // ✅ stringify before saving
      state.cardCurrencyName = action.payload;
    },
    clearCardCurrencyName: (state) => {
      localStorage.removeItem("cardCurrencyName");
      state.cardCurrencyName = null;
    },
    clearRoleName: (state) => {
      localStorage.removeItem("roleName");
      state.roleName = null;
    },
    clearAdvisorName: (state) => {
      localStorage.removeItem("advisorName");
      state.advisorName = null;
    },
    clearSubAdvisorName: (state) => {
      localStorage.removeItem("subAdvisorName");
      state.subAdvisorName = null;
    },
    clearCustomerName: (state) => {
      localStorage.removeItem("customerName");
      state.customerName = null;
    },
    clearUsername: (state) => {
      localStorage.removeItem("username");
      state.username = null;
    },
    clearUserId: (state) => {
      localStorage.removeItem("userid");
      state.userId = null;
    },
    clearUserProfilePicDownloadUrl: (state) => {
      localStorage.removeItem("userProfilePicDownloadUrl");
      state.userProfilePicDownloadUrl = null;
    },
    clearUserProfilePic: (state) => {
      localStorage.removeItem("userProfilePic");
      state.userProfilePic = null;
    },
    setFileIdsRedux: (state, action) => {
      state.fileIdsRedux = action.payload;
    },
    clearFileIdsRedux: (state) => {
      state.fileIdsRedux = [];
    },
    UpdateFieldStatusTrue: (state, action) => {
      state.updateFieldStatus = true;
    },
    UpdateFieldStatusFalse: (state) => {
      state.updateFieldStatus = false;
    },
  },
});

export const {
  setUsername,
  clearUsername,
  setUserIdStore,
  clearUserId,
  setUserProfilePic,
  clearUserProfilePic,
  clearUserProfilePicDownloadUrl,
  setUserProfilePicDownloadUrl,
  setRoleName,
  clearRoleName,
  setAdvisorNameRedux,
  setCustomerNameRedux,
  clearAdvisorName,
  clearCustomerName,
  setSubAdvisorNameRedux,
  clearSubAdvisorName,
  setCardCurrencyName,
  clearCardCurrencyName,
  setFileIdsRedux,
  clearFileIdsRedux,
  UpdateFieldStatusFalse,
  UpdateFieldStatusTrue,
} = userSlice.actions;
export default userSlice.reducer;
